import {
  Component,
  Input,
  QueryList,
  ContentChildren,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  OnDestroy
} from '@angular/core';

import {
  style,
  trigger,
  transition,
  animate
} from '@angular/animations';

import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

import { SkyVerticalTabComponent } from './vertical-tab.component';
import { SkyVerticalTabsetService } from './vertical-tabset.service';


export class SkyVerticalTabsetGroupComponent implements OnInit, OnDestroy {

  
  public groupHeading: string;

  
  public disabled: boolean;

  private _open: boolean = false;
  private _openBeforeTabsHidden: boolean = false;
  private _ngUnsubscribe = new Subject();

  public get open(): boolean {
    return !this.disabled && this._open;
  }

  
  public set open(value: boolean) {
    this._open = value;
  }

  
  private tabs: QueryList<SkyVerticalTabComponent>;

  constructor(
    private tabService: SkyVerticalTabsetService,
    private changeRef: ChangeDetectorRef) {}

  public ngOnInit() {
    this.tabService.hidingTabs
      .takeUntil(this._ngUnsubscribe)
      .subscribe(this.tabsHidden);

    this.tabService.showingTabs
      .takeUntil(this._ngUnsubscribe)
      .subscribe(this.tabsShown);

    this.tabService.tabClicked
      .takeUntil(this._ngUnsubscribe)
      .subscribe(this.tabClicked);
  }

  public ngOnDestroy() {
    this._ngUnsubscribe.next();
    this._ngUnsubscribe.complete();
  }

  public toggleMenuOpen() {
    if (!this.disabled) {
      this.open = !this.open;
    }

    this.changeRef.markForCheck();
  }

  public subMenuOpen(): boolean {
    return this.tabs && (this.tabs.find(t => t.active) !== undefined);
  }

  public tabClicked = () => {
    this.changeRef.markForCheck();
  }

  public tabsHidden = () => {
    // this fixes an animation bug with ngIf when the parent component goes from visible to hidden
    this._openBeforeTabsHidden = this.open;
    this.open = false;
    this.changeRef.detectChanges();
  }

  public tabsShown = () => {
    this.open = this._openBeforeTabsHidden;
    this.changeRef.detectChanges();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-vertical-tabset-group',
  template: `<div class="sky-vertical-tabset-group">
  <div
    class="sky-vertical-tabset-group-header" 
    [ngClass]="{'sky-vertical-tabset-group-header-sub-open': subMenuOpen()}"
    (click)="toggleMenuOpen()"
    (keyup.enter)="toggleMenuOpen()"
    [tabIndex]="-1"
  >
    {{ groupHeading }}
    <sky-chevron 
      class="sky-vertical-tabset-group-header-chevron"
      [direction]="open ? 'up' : 'down'"
      [disabled]="disabled"
      (directionChange)="toggleMenuOpen()"
      (keyup.enter)="$event.stopPropagation()"
    >
    </sky-chevron>
  </div>
  <div
    class="sky-vertical-tabset-group-content"
    *ngIf="open"
    [@tabSlide]
  >
    <ng-content></ng-content>
  </div>
</div>
`,
  styles: [`.sky-vertical-tabset-group {
  border-bottom: 1px solid #e2e3e4;
  margin: 5px 0 5px 5px;
}

.sky-vertical-tabset-group-header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-family: "Blackbaud Sans", "Helvetica Neue", Arial, sans-serif;
  color: #282b31;
  font-weight: 600;
  font-size: 16px;
  font-weight: 400;
  color: #686c73;
}

.sky-vertical-tabset-group-header:hover {
  color: #282b31;
}

.sky-vertical-tabset-group-header:focus {
  outline: thin dotted;
  outline: -webkit-focus-ring-color auto 5px;
}

:host[ng-reflect-disabled="true"] .sky-vertical-tabset-group-header {
  cursor: not-allowed;
  font-style: italic;
  opacity: 0.8;
}

:host[ng-reflect-disabled="true"] .sky-vertical-tabset-group-header:hover {
  color: #686c73;
}

:host[ng-reflect-disabled="true"] .sky-vertical-tabset-group-header /deep/ button {
  cursor: not-allowed;
}

.sky-vertical-tabset-group-header-sub-open {
  font-family: "Blackbaud Sans", "Helvetica Neue", Arial, sans-serif;
  color: #282b31;
  font-weight: 600;
  font-size: 16px;
}

.sky-vertical-tabset-group-content {
  overflow: hidden;
  border-top: 1px solid #e2e3e4;
}

:host /deep/ .sky-vertical-tabset-group-header-chevron > button {
  font-size: 14px !important;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger(
      'tabSlide', [
        transition(':enter', [
          style({
            height: '0',
            visibility: 'hidden'
          }),
          animate('150ms ease-in', style({
            height: '*',
            visibility: 'visible'
          }))
        ]),
        transition(':leave', [
          style({
            height: '*',
            visibility: 'visible'
          }),
          animate('150ms ease-in', style({
            height: '0',
            visibility: 'hidden'
          }))
        ])
      ])
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyVerticalTabsetService, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'groupHeading': [{ type: Input },],
'disabled': [{ type: Input },],
'open': [{ type: Input },],
'tabs': [{ type: ContentChildren, args: [SkyVerticalTabComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
